export default {
  route: {
    configCamera: '摄像头设置',
    configWorkerLevel: '员工等级',
    config: '设置',
    profile: '首页',
    dataWorkbench: '量化工作台',
    dataWorkbenchIndex: '数据编排工作台',
    other: '其他',
    AdminLog: '日志',
    permission: '权限',
    permissionMark: '权限资源',
    permissionRole: '角色列表',
    permissionAdmin: '管理员列表',
    permissionAllAdmin: '平台管理员',
    hsgt: '沪深港通',
    hsgtLgtRow: '陆股通',
    hsgtLgtCol: '陆股通(旧)',
    hsgtLgtOnePlus: '陆股通+1OPEN',
    shareholders: '十大股东',
    shareholdersAll: '全部十大股东',
    shareholdersNum: '股东数',
    shareholdersNumTen: '十大股东+1',
    user: '我的自选股',
    userStock: '操作自选股',
    userStockNote: '笔记自选股',
    totalDayK: '日K',
    userWinner: '龙虎榜自选股',
    searchExplore2: '探索2',
    searchExplore3: '探索3',
    searchExplore4: '探索4',
    searchExplore5: '探索5',
    // 与路由 meta.title 保持一致，用于侧边栏菜单和页签的中文名称。
    searchExplore6: '探索6',
    searchExplore7: '探索7',
    winner: '龙虎榜',
    winner_cal_open: '龙丶量化计算',
    shareholdersWinner: '股丶量化计算',
    winner_overview: '龙虎榜总览',
    winner_open: '龙虎榜+1open',
    winner_open_mark: '龙虎榜标注',
    winner_cal_close: '量化计算[close]',
    winner_flow_calendar: '龙虎榜日历',
    winner_attention_calendar: '关注日历',
    winner_much_calendar: '做多日历',
    winner_empty_calendar: '做空日历',
    winner_self_mock: '自选模拟',
    shareholdersNumTenOnePlus: '十大股东+1',
    winner_self: '龙虎榜自选',
    famous: '名人战法',
    famousIndex: '名人战法',
    totalIc: '行业&概念',
    total: '总览',
    rzrq: '融资融券',
    industry: '行业',
    industrySw3: '申万三',
    search: '搜索',
    searchExplore1: '探索1',
    shareholdersStock: '十大流通股东',
    rzrqIndex: '融资融券',
    rzrqMark: '融资标注',
    totalMinute: '分时',
    winner_daily: '当日龙虎榜'
  },
  toast: {
    switchLangSuccess: '切换语言成功'
  },
  tagsView: {
    refresh: '刷新',
    closeRight: '关闭右侧',
    closeOther: '关闭其他'
  },
  theme: {
    themeColorChange: '主题色更换',
    themeChange: '主题更换'
  },
  universal: {
    title: '提示',
    confirm: '确定',
    cancel: '取消'
  },
  navBar: {
    themeChange: '主题修改',
    headerSearch: '页面搜索',
    screenfull: '全屏替换',
    lang: '国际化',
    guide: '功能引导',
    home: '首页',
    course: '课程主页',
    logout: '退出登录'
  },
  guide: {
    close: '关闭',
    next: '下一个',
    prev: '上一个',
    guideTitle: '引导',
    guideDesc: '打开引导功能',
    hamburgerTitle: '汉堡按钮',
    hamburgerDesc: '打开和关闭左侧菜单',
    breadcrumbTitle: '面包屑',
    breadcrumbDesc: '指示当前页面位置',
    searchTitle: '搜索',
    searchDesc: '页面链接搜索',
    fullTitle: '全屏',
    fullDesc: '页面显示切换',
    themeTitle: '主题',
    themeDesc: '更换项目主题',
    langTitle: '国际化',
    langDesc: '语言切换',
    tagTitle: '标签',
    tagDesc: '已打开页面标签',
    sidebarTitle: '菜单',
    sidebarDesc: '项目功能菜单'
  }
}
